<template>
  <div>
    <div class="elasticLoadBalancingResourceGcp-title">
      <div>{{ $t("RAM.ALI.ElasticLoadBalancer.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:elasticLoadBalancingResourceGcp:update'
          ]"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:elasticLoadBalancingResourceGcp:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticLoadBalancingResourceGcp-top">
      <elastic-load-balancing-resource-gcp-search
        ref="search"
      ></elastic-load-balancing-resource-gcp-search>
    </div>
    <table-elastic-load-balancing-resource-gcp></table-elastic-load-balancing-resource-gcp>
  </div>
</template>

<script>
import ElasticLoadBalancingResourceGcpSearch from "../elb/ElasticLoadBalancingResourceGcpSearch";
import TableElasticLoadBalancingResourceGcp from "../elb/TableElasticLoadBalancingResourceGcp";

export default {
  name: "elasticLoadBalancingResourceGcp",
  components: {
    ElasticLoadBalancingResourceGcpSearch,
    TableElasticLoadBalancingResourceGcp
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 4,
          accountType: 4
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      this.loadbalancerId = this.$refs.search.loadbalancerId;
      this.name = this.$refs.search.name;
      this.accountIds = this.$refs.search.accountIds;
      this.accountName = this.$refs.search.accountName;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportGcpLoadBalancer({
          companyId: this.companyId,
          loadbalancerId: this.loadbalancerId,
          name: this.name,
          accountIds: this.accountIds,
          accountName: this.accountName
        })
        .then(res => {
          let fileName = this.$t('RAM.export.elasticLoadBalancer');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.elasticLoadBalancingResourceGcp-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.elasticLoadBalancingResourceGcp-title > div:nth-child(1) {
  float: left;
}
.elasticLoadBalancingResourceGcp-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticLoadBalancingResourceGcp-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/elb/ElasticLoadBalancingResourceGcp.vue